<template>
  <div
    class="deviceManageDialog absolute_center"
    :class="{
      _boxBg_dark_secondLevel: styleType == 'typeDark',
      _boxBg_green_secondLevel: styleType == 'typeGreen',
      _boxBg_blue_secondLevel: styleType == 'typeBlue',
      _boxBg_strong_secondLevel: styleType == 'typeStrong',
    }"
  >
    <div class="selfClose_btn" @click="close()"></div>
    <div class="_boxTitle">全厂设备运行管理</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="mem_main_box">
        <div class="top_msg_box">
          <div class="important_follow_box">
            <div class="important_inner">
              <div class="important_inner_name">
                <p class="num">{{ production + monitor + government }}</p>
                <p class="blueFont">全厂设备总数</p>
              </div>
            </div>
            <div class="important_inner">
              <div class="important_inner_name">
                <p class="num">{{ monitor }}</p>
                <p class="blueFont">监测设备总数</p>
              </div>
            </div>
            <div class="important_inner">
              <div class="important_inner_name">
                <p class="num">{{ government }}</p>
                <p class="blueFont">治理设备总数</p>
              </div>
            </div>
            <div class="important_inner">
              <div class="important_inner_name">
                <p class="num">{{ production }}</p>
                <p class="blueFont">生产设备总数</p>
              </div>
            </div>
          </div>
        </div>
        <div class="public-form">
          <div class="public-form-left">
            <el-form :inline="true" class="secondLevel-form-inline">
              <el-form-item class="secondLevel-label" label="分厂/所属区域：">
                <el-select
                  class="secondLevel-select"
                  v-model="params.branchFactoryId"
                  placeholder="全部"
                >
                  <el-option label="全部" value></el-option>
                  <el-option
                    v-for="(item, i) in nameIdData"
                    :key="i"
                    :label="item.name"
                    :value="item.nameId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="secondLevel-label" label="设备类别：">
                <el-select
                  class="secondLevel-select"
                  v-model="params.categoryCode"
                  placeholder="全部"
                  @change="categoryCodeChange()"
                >
                  <el-option label="全部" value></el-option>
                  <el-option label="监测设备" value="3"></el-option>
                  <el-option label="治理设备" value="2"></el-option>
                  <el-option label="生产设备" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="secondLevel-label" label="设备类型：">
                <el-select
                  class="secondLevel-select"
                  v-model="params.typeId"
                  placeholder="全部"
                >
                  <el-option label="全部" value></el-option>
                  <el-option
                    v-for="(item, i) in typeIdData"
                    :key="i"
                    :label="item.type_name"
                    :value="item.type_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="secondLevel-label" label="设备状态：">
                <el-select
                  class="secondLevel-select"
                  v-model="params.status"
                  placeholder="全部"
                >
                  <el-option label="全部" value></el-option>
                  <el-option label="在线" value="3"></el-option>
                  <el-option label="离线" value="4"></el-option>
                  <el-option label="运行" value="1"></el-option>
                  <el-option label="停止" value="0"></el-option>
                  <el-option label="无数据" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="secondLevel-label" label="设备编码/名称：">
                <el-input
                  class="secondLevel-input"
                  v-model="params.keyword"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item style="margin-left: 10px" class="secondLevel-label">
                <a class="self_btn" @click="check_click">查询</a>
                <a class="self_btn" @click="reset_click">重置</a>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table_box">
          <el-table
            :header-cell-class-name="getHeaderCellClass"
            :header-row-class-name="getHeadRowClass"
            :cell-class-name="getCellClass"
            :row-class-name="getRowClass"
            class="secondLevel_table"
            :data="tableData"
            @row-click="rowClick"
            id="secondLevel_table"
          >
            <el-table-column
              align="center"
              type="index"
              width="100px"
              label="序号"
              prop
            >
              <template #default="scope">
                <span :class="{ baogang: reactBaoGang }">
                  {{
                    scope.$index +
                    1 +
                    (Number(pageNo) - 1) * Number(pageSize ? pageSize : 50)
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="分厂/所属区域"
              prop="branchFactory"
            >
              <template #default="scope">
                <span :class="{ baogang: reactBaoGang }">
                  {{ scope.row.branchFactory ? scope.row.branchFactory : "--" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="设备编码"
              prop="deviceNo"
              width="300px"
            >
              <template #default="scope">
                <span
                  :class="{ baogang: reactBaoGang }"
                  :title="scope.row.deviceNo ? scope.row.deviceNo : '--'"
                >
                  {{ scope.row.deviceNo ? scope.row.deviceNo : "--" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="设备名称"
              prop="deviceName"
              width="300px"
            >
              <template #default="scope">
                <span
                  :title="scope.row.deviceName ? scope.row.deviceName : '--'"
                  :class="{ baogang: reactBaoGang }"
                >
                  {{ scope.row.deviceName ? scope.row.deviceName : "--" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="设备类别"
              prop="primaryTypeName"
            >
              <template #default="scope">
                <span :class="{ baogang: reactBaoGang }">
                  {{
                    scope.row.primaryTypeName ? scope.row.primaryTypeName : "--"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="设备类型"
              prop="lastTypeName"
            >
              <template #default="scope">
                <span :class="{ baogang: reactBaoGang }">
                  {{ scope.row.lastTypeName ? scope.row.lastTypeName : "--" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="设备状态" prop="realStatus">
              <template #default="scope">
                <span
                  class="status_span"
                  :class="{
                    statusActive:
                      scope.row.realStatus == 1 || scope.row.realStatus == 3,
                    baogang: reactBaoGang,
                  }"
                  >{{ realStatus(scope.row.realStatus) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template #default="scope">
                <span
                  class="view-detail"
                  style="cursor: pointer; color: #00fcff"
                  :style="{
                    color:
                      scope.row.primaryTypeId == 2 &&
                      scope.row.typeId != 1539730903712221 &&
                      scope.row.typeId != 1539730825110001 &&
                      scope.row.typeId != 1539730887855002 &&
                      scope.row.typeId != 1539730887855003 &&
                      scope.row.typeId != 1539730903712004 &&
                      scope.row.typeId != 1539730903712005 &&
                      scope.row.typeId != 1539730887855001 // 除尘器
                        ? '#c0c4cc'
                        : '#00FCFF',
                  }"
                  >查看详情</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          class="secondLevel-pagination_box pagination"
          v-if="!pagination && tableData.length"
        >
          <el-pagination
            :page-size="50"
            layout="total,prev, pager, next,jumper"
            :total="total"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
          />
          <p>跳转</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iframePup from "@/modules/iframePup/iframePup.vue";
import mybus from "@/utils/eventbus";
import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';

export default {
  name: "aqiDialog",
  title: "历史查询",
  props: ["globalInstance", "production", "government", "monitor"],
  setup(props) {
    const production = props.production;
    const government = props.government;
    const monitor = props.monitor;
    const globalInstance = props.globalInstance;
    return { globalInstance, production, government, monitor };
  },
  data() {
    return {
      pageInfo: "deviceManageDialog/index.vue",
      computedName: "全厂设备运行管理弹框组件",
      customerId: this.globalInstance.$store.state.customerId,
      params: {
        branchFactoryId: "",
        categoryCode: "",
        typeId: "",
        status: "",
        keyword: "",
      },
      pageNo: 1,
      pageSize: 50,
      tableData: [],
      nameIdData: [],
      typeIdData: [],
      deviceList: [],
      total: 0,
      styleType: "",
    };
  },
  created() {
    this.styleType = this.globalInstance.$store.state.styleType;
  },
  mounted() {
    this.getareaList();
    this.getDeviceList();
    this.check_click();
    mybus.$on("showAllEquipment", (val) => {
      if (val === false || val == "0") {
        this.close();
      }
    });
  },
  computed: {
    curStyleTypeVal() {
      return this.globalInstance.$store.state.styleType;
    },
    realStatus() {
      return function (status) {
        let returnStatus = "";
        switch (status) {
          case 0:
            returnStatus = "停止";
            break;
          case 1:
            returnStatus = "运行";
            break;
          case 2:
            returnStatus = "无数据";
            break;
          case 3:
            returnStatus = "在线";
            break;
          case 4:
            returnStatus = "离线";
            break;
        }
        return returnStatus;
      };
    },
    getHeaderCellClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "thClass";
        } else if (this.styleType == "typeGreen") {
          return "thClass_green";
        }
      };
    },

    getHeadRowClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "headTrClass";
        } else if (this.styleType == "typeGreen") {
          return "headTrClass_green";
        }
      };
    },

    getCellClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "tdClass";
        } else if (this.styleType == "typeGreen") {
          return "tdClass_green";
        }
      };
    },

    getRowClass() {
      return (obj) => {
        if (this.styleType == "typeDark") {
          return "trClass";
        } else if (this.styleType == "typeGreen") {
          return "trClass_green";
        }
      };
    },
    reactBaoGang() {
      if (this.customerId === 66) {
        return "baogang";
      } else {
        return "";
      }
    },
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  beforeUnmount() {},
  methods: {
    check_click() {
      this.pageNo = 1;
      this.getData();
    },
    async getData() {
      let paramsList = {
        customerId: this.customerId,
        branchFactoryId: this.params.branchFactoryId,
        categoryCode: this.params.categoryCode,
        typeId: this.params.typeId,
        status: this.params.status,
        keyword: this.params.keyword,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      let getDeviceInfos =
        CONFIG.requestName + this.globalInstance.$apiOpt.getDeviceInfos;
      let data = await this.globalInstance.$apiUtils.get(
        getDeviceInfos,
        paramsList
      );
      this.tableData = data.records;
      this.total = data.total;
    },
    reset_click() {
      this.params = {
        branchFactoryId: "",
        categoryCode: "",
        typeId: "",
        status: "",
        keyword: "",
      };
      this.pageNo = 1;
      this.categoryCodeChange();
      this.getData();
    },
    rowClick(e) {
      let openUrl = window.bmeConfig.baseUrlHttp;
      if (this.customerId == 58) {
        // 常州中天二级菜单地址单独配置
        openUrl = "http://192.168.138.158:4050"; // 能环处 158. 行政楼 http://192.168.18.168:4050
      }
      if (this.customerId == 15) {
        // 常州中天二级菜单地址单独配置
        openUrl = "http://10.3.34.59:4046"; // 安钢还有增强版 公用一个二级菜单地址
      }
      if (e.primaryTypeId == 3) {
        //监测设备
        this.globalInstance.$store.commit("dialogStatus", true);
        this.globalInstance.$popup.open(
          iframePup,
          this.globalInstance.dialogCompontent,
          this.globalInstance,
          {
            dialog: `${openUrl}/standard/${
              window.CONFIG.requestName
            }/page/monitor/monitor_equip_manage.html?customerId=${
              this.customerId
            }&sourceType=1&style=${
              this.styleType
            }&deviceNo=${encodeURIComponent(e.deviceNo)}` + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
            type: false,
          }
        );
      } else if (e.primaryTypeId == 1) {
        //生产设备
        this.globalInstance.$store.commit("dialogStatus", true);
        this.globalInstance.$popup.open(
          iframePup,
          this.globalInstance.dialogCompontent,
          this.globalInstance,
          {
            dialog: `${openUrl}/standard/${
              window.CONFIG.requestName
            }/page/controlEquipment/productionEquipment.html?customerId=${
              this.customerId
            }&sourceType=1&style=${
              this.styleType
            }&deviceNo=${encodeURIComponent(e.deviceNo)}` + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
            type: false,
          }
        );
      } else if (e.primaryTypeId == 2) {
        let dialog = "";
        //治理设备
        if (
          e.typeId == 1539730825110001 || //雾炮
          e.typeId == 1539730903712221 //干雾
        ) {
          dialog = `${openUrl}/standard/${
            window.CONFIG.requestName
          }/page/noOrganizationEquipment/sprayDustSuppression.html?customerId=${
            this.customerId
          }&sourceType=1&style=${this.styleType}&deviceNo=${encodeURIComponent(
            e.deviceNo
          )}` + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
        } else if (
          e.typeId == 1539730887855002 || //布袋除尘器
          e.typeId == 1539730887855003 || //静电除尘器
          e.typeId == 1539730800534001 || //纳膜设备
          e.typeId == 1539730903712005 || // 净化
          e.typeId == 1539730887855001 // 除尘器
        ) {
          dialog = `${openUrl}/standard/${
            window.CONFIG.requestName
          }/page/noOrganizationEquipment/dustCollector.html?customerId=${
            this.customerId
          }&sourceType=1&style=${this.styleType}&deviceNo=${encodeURIComponent(
            e.deviceNo
          )}` + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
        } else if (
          e.typeId == 1539730903712004 //脱硫脱硝
        ) {
          dialog = `${openUrl}/standard/${
            window.CONFIG.requestName
          }/page/organized/desulfurization_denitrification.html?customerId=${
            this.customerId
          }&sourceType=1&style=${this.styleType}&deviceNo=${encodeURIComponent(
            e.deviceNo
          )}` + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
        } else if (e.typeId == 1539730887856001) {
          dialog = `${openUrl}/standard/${
            window.CONFIG.requestName
          }/page/noOrganizationEquipment/vocEquipmentNew.html?customerId=${
            this.customerId
          }&sourceType=1&style=${
            this.styleType
          }&deviceNoDp=${encodeURIComponent(e.deviceNo)}` + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : '');
        }
        if (!!dialog) {
          this.globalInstance.$store.commit("dialogStatus", true);
          this.globalInstance.$popup.open(
            iframePup,
            this.globalInstance.dialogCompontent,
            this.globalInstance,
            {
              dialog: dialog,
              type: false,
            }
          );
        }
      }
    },
    async getareaList() {
      let getNameId =
        CONFIG.requestName + this.globalInstance.$apiOpt.getNameId;
      let data = await this.globalInstance.$apiUtils.get(getNameId, {
        customerId: this.customerId,
      });
      if (data) this.nameIdData = data || [];
    },
    async getdeviceNum() {
      let getNameId =
        CONFIG.requestName + this.globalInstance.$apiOpt.getNameId;
      let data = await this.globalInstance.$apiUtils.get(getNameId, {
        customerId: this.customerId,
      });
      if (data) this.nameIdData = data || [];
    },
    async getDeviceList() {
      let getAllEffectiveDeviceType =
        CONFIG.requestName +
        this.globalInstance.$apiOpt.getAllEffectiveDeviceType;
      let data = await this.globalInstance.$apiUtils.get(
        getAllEffectiveDeviceType,
        {
          customerId: this.customerId,
        }
      );
      this.deviceList = data;
      this.deviceListSel(this.deviceList);
    },
    deviceListSel(data) {
      if (!this.params.categoryCode) {
        if (data) this.typeIdData = data || [];
      } else if (this.params.categoryCode == 1) {
        if (data && data.length > 0) {
          let tmpList = [];
          let productionIds = [1];
          data.forEach((element) => {
            if (
              element.type_id &&
              $.inArray(element.type_id, productionIds) >= 0
            ) {
              tmpList.push(element);
            }
          });
          this.typeIdData = tmpList || [];
        }
      } else if (this.params.categoryCode == 3) {
        if (data && data.length > 0) {
          let tmpList = [];
          let productionIds = [
            1539730672078012, 1539730672078001, 1539730672078009,
            1539730673000001, 1539730699168001, 1539730750575001,
            1539730750575002, 1539730750575003, 1539730750575004,
            1539730750575008, 1539730750575009, 1626143139164001,
            1539730672078201, 1539730750575007, 1539730672108001,
          ];
          data.forEach((element) => {
            if (
              element.type_id &&
              $.inArray(element.type_id, productionIds) >= 0
            ) {
              tmpList.push(element);
            }
          });
          this.typeIdData = tmpList || [];
        }
      } else if (this.params.categoryCode == 2) {
        if (data && data.length > 0) {
          let tmpList = [];
          let productionIds = [
            1539730825110001, 1539730887855002, 1539730887855003,
            1539730903712004, 1539730903712221, 1539730903712005,
            1539730887855001, 1539730887856001, 1539730800534001,
          ];
          data.forEach((element) => {
            if (
              element.type_id &&
              $.inArray(element.type_id, productionIds) >= 0
            ) {
              tmpList.push(element);
            }
          });
          this.typeIdData = tmpList || [];
        }
      }
      this.params.typeId = "";
    },
    categoryCodeChange() {
      this.deviceListSel(this.deviceList);
    },
    handleCurrentChange(val) {
      this.tableData = [];
      this.pageNo = val;
      this.getData();
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
  },
};
</script>

<style lang="scss" scoped>
// 针对卫星版（例：浙江万泰大屏62）弹窗高度大于二级菜单调整
._boxBg_blue_secondLevel {
  height: 920px;
  ._boxTitle {
    margin-bottom: 20px;
  }
}
// 针对增强版

.absolute_center {
  top: 49%;
}
.deviceManageDialog .secondLevel-pagination_box {
  margin: 0;
}

.mem_main_box {
  height: 100%;
  position: relative;
  .top_msg_box {
    height: 144px;
    position: relative;
    .important_follow_box {
      width: 100%;
      height: 144px;
      background: linear-gradient(
        180deg,
        rgba(108, 115, 255, 0.34) 0%,
        rgba(107, 151, 255, 0.2) 48%,
        rgba(58, 116, 255, 0.1) 100%,
        #0049fa 100%,
        #0049fa 100%
      );
      border: 1px solid #8badff;
      position: relative;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .important_inner {
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        // padding: 18px 10px 0 125px;
        position: relative;
        &::after {
          content: "";
          width: 2px;
          height: 88px;
          position: absolute;
          top: 50%;
          margin-top: -44px;
          right: -137px;
          background: rgb(9, 7, 32);
        }
        .important_inner_name {
          align-items: center;
          .num {
            font-size: 60px;
            font-weight: 400;
            font-style: italic;
            color: rgba(255, 255, 255, 1);
            line-height: 60px;
            text-shadow: #00ffaa 0px 0px 10px;
            text-align: center;
          }
          .blueFont {
            font-size: 20px;
            line-height: 33px;
            color: #5bb4ff;
          }
        }
      }
    }
  }
  .public-form {
    .public-form-left {
      .secondLevel-form-inline {
        .secondLevel-label {
          .el-form-item__label {
            // color: #99f5ff !important;
            // font-size: 20px;
            // padding: 0 8px 0 0;
          }
        }
        .secondLevel-select {
          width: 218px;
          height: 40px;
          border: 1px solid #99f5ff;
          color: #99f5ff;
          background: #071127;
          font-size: 16px;
        }
      }
    }
  }
  .secondLevel-pagination {
    display: flex;
    // align-items: center;
    justify-content: flex-end;
  }
}
.status_span {
  position: relative;
  vertical-align: middle;
  &::before {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    background: rgba(138, 144, 153, 1);
    border-radius: 50%;
    margin-right: 10px;
  }
}
.statusActive:before {
  content: "";
  display: inline-block;
  width: 10px;
  height: 10px;
  background: rgba(0, 255, 0, 1);
  border-radius: 50%;
}
</style>
<style lang="scss" scoped>
._boxBg_green_secondLevel {
  .mem_main_box {
    .top_msg_box {
      .important_follow_box {
        background: rgba(6, 56, 53, 0.7);
        border: 1px solid #05fffa;
        box-shadow: 6px 5px 14px 2px #05fbf6;
        border-radius: 15px;
        .important_inner {
          &::after {
            background: rgb(33, 177, 187);
          }
          .important_inner_name {
            .num {
            }
            .blueFont {
              color: #c8dde1;
            }
          }
        }
      }
    }
    .public-form {
      margin-top: 10px;
      .public-form-left {
        .secondLevel-form-inline {
          .secondLevel-label {
            .el-form-item__label {
            }
          }
          .secondLevel-select {
            width: 218px;
            height: 40px;
            border: 1px solid #99f5ff;
            color: #99f5ff;
            background: #071127;
            font-size: 16px;
          }
        }
      }
    }
    .secondLevel-pagination {
      display: flex;
      // align-items: center;
      justify-content: flex-end;
    }
  }
  .status_span {
    position: relative;
    vertical-align: middle;
    &::before {
      content: "";
      display: inline-block;
      width: 10px;
      height: 10px;
      background: rgba(138, 144, 153, 1);
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  .statusActive:before {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    background: rgba(0, 255, 0, 1);
    border-radius: 50%;
  }
}
</style>
<style lang="scss" scoped>
._boxBg_strong_secondLevel {
  .mem_main_box {
    .top_msg_box {
      .important_follow_box {
        border: 1px solid #0569ff;
        box-shadow: 6px 5px 14px 2px #0940d9;
        border-radius: 15px;
        .important_inner {
          &::after {
            background: rgb(33, 177, 187);
          }
          .important_inner_name {
            .num {
            }
            .blueFont {
              color: #c8dde1;
            }
          }
        }
      }
    }
    .public-form {
      margin-top: 10px;
      .public-form-left {
        .secondLevel-form-inline {
          .secondLevel-label {
            .el-form-item__label {
            }
          }
          .secondLevel-select {
            width: 218px;
            height: 40px;
            border: 1px solid #99f5ff;
            color: #99f5ff;
            background: #071127;
            font-size: 16px;
          }
        }
      }
    }
    .secondLevel-pagination {
      display: flex;
      // align-items: center;
      justify-content: flex-end;
    }
  }
  .status_span {
    position: relative;
    vertical-align: middle;
    &::before {
      content: "";
      display: inline-block;
      width: 10px;
      height: 10px;
      background: rgba(138, 144, 153, 1);
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  .statusActive:before {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    background: rgba(0, 255, 0, 1);
    border-radius: 50%;
  }
}
</style>
<style lang="scss">
.deviceManageDialog {
  .secondLevel-label {
    .el-form-item__label {
      color: #99f5ff !important;
      font-size: 20px;
      padding: 0 8px 0 0;
    }
  }
  .table_box {
    height: 450px !important;
    // overflow: auto;
    .secondLevel_table {
      border: 1px solid #84aaff40 !important;
      background: #01132d40 !important;
      pointer-events: all;
      .el-table__body-wrapper {
        overflow-y: auto;
        height: 400px;
      }
    }
    .thClass {
      background: #01122ba6 !important;
      border-bottom: 1px solid #cccccc28 !important;
    }

    .thClass > .cell {
      font-size: 22px;
      color: rgba(200, 216, 255, 1);
      text-align: center !important;
    }

    .tdClass {
      border-right: 1px solid #84aaff40 !important;
      border-bottom: 1px solid #84aaff40 !important;
      background: #01122b66 !important;
    }
    .tdClass > .cell {
      height: 27px;
      font-size: 22px !important;
      color: #afafaf !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .headTrClass {
      border: 1px solid rgba(132, 170, 255, 0.5) !important;
    }

    .thClass_green {
      background: rgba(0, 73, 76, 0.8) !important;
      border-bottom: 1px solid rgba(5, 255, 250, 0.2) !important;
    }

    .thClass_green > .cell {
      font-size: 22px;
      color: rgba(200, 216, 255, 1);
      text-align: center !important;
    }

    .tdClass_green {
      border-right: 1px solid rgba(5, 255, 250, 0.2) !important;
      border-bottom: 1px solid rgba(5, 255, 250, 0.2) !important;
      background: rgba(178, 254, 252, 0.2) !important;
    }
    .tdClass_green > .cell {
      font-size: 22px !important;
      color: #afafaf !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .headTrClass_green {
      border: 1px solid rgba(5, 255, 250, 1) !important;
    }
  }
}
</style>
<style>
/* 分页 */
.deviceManageDialog .secondLevel-pagination_box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* margin: 30px 100px 0 0; */
  margin: 20px 0 0 0;
}
.deviceManageDialog .secondLevel-pagination_box p {
  font-size: 28px;
}
.deviceManageDialog
  .secondLevel-pagination_box
  .el-pagination
  .el-pagination__total {
  margin-right: 50px;
}
.deviceManageDialog .secondLevel-pagination_box .el-pagination {
  text-align: right;
  padding: 0 130px 0 0;
}
.deviceManageDialog .secondLevel-pagination_box .el-pagination button,
.deviceManageDialog .el-pagination span:not([class*="suffix"]) {
  font-size: 26px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
}
.deviceManageDialog .secondLevel-pagination_box .el-pager li,
.deviceManageDialog .secondLevel-pagination_box .el-pager li.btn-quicknext,
.deviceManageDialog .secondLevel-pagination_box .el-pager li.btn-quickprev {
  font-size: 26px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
  background: transparent;
}
.deviceManageDialog .secondLevel-pagination_box .el-pager li.active {
  color: #55abf9;
}
.deviceManageDialog .secondLevel-pagination_box .el-pagination .btn-next,
.deviceManageDialog .el-pagination .btn-prev,
.deviceManageDialog .el-pagination button:disabled {
  background: transparent;
  color: #ffffff;
}
.deviceManageDialog
  .secondLevel-pagination_box
  .el-pagination
  .btn-next
  .el-icon,
.deviceManageDialog .el-pagination .btn-prev .el-icon {
  font-size: 28px;
}
.deviceManageDialog
  .secondLevel-pagination_box
  .el-pagination__editor.el-input {
  width: 80px;
  height: 50px;
}
.deviceManageDialog
  .secondLevel-pagination_box
  .el-pagination__editor.el-input
  .el-input__inner {
  height: 36px;
  font-size: 22px;
  border: 1px solid #dcdfe6;
  background: transparent;
  color: #fff;
}
._boxBg_blue_secondLevel
  .el-select__popper
  .el-select-dropdown
  .el-scrollbar
  .el-select-dropdown__wrap
  .el-scrollbar__view
  .el-select-dropdown__item {
  color: #fff;
}
.baogang {
  color: #fff;
}
</style>
